import React from 'react'
import { useTranslation } from 'react-i18next'
import i18n from '@src/i18n'

import Hero from '../../components/Hero'
import Article from '../../components/Article'
import Section from '../../components/Section'

export interface BambooProps {}

const HERO_IMAGE = '/paywalls/bamboo/hero.png'

const ARTICLES = [
  {
    title: i18n.t('paywalls:bamboo.articles.setUp.title'),
    text: i18n.t('paywalls:bamboo.articles.setUp.text'),
    image: '/paywalls/bamboo/set-up.png',
  },
  {
    title: i18n.t('paywalls:bamboo.articles.work.title'),
    text: i18n.t('paywalls:bamboo.articles.work.text'),
    image: '/paywalls/bamboo/work.png',
  },
  {
    title: i18n.t('paywalls:bamboo.articles.sync.title'),
    text: i18n.t('paywalls:bamboo.articles.sync.text'),
    image: '/paywalls/bamboo/sync.png',
  },
]

export const Bamboo: React.FC<BambooProps> = () => {
  const { t } = useTranslation('paywalls', { keyPrefix: 'bamboo' })
  return (
    <>
      <Hero title={t('hero.title')} image={HERO_IMAGE} subtitle={t('hero.subtitle')} />
      <Section title={t('section.title')} text={t('section.text')} />
      <div className="flex flex-col gap-6">
        {ARTICLES.map((article, index) => (
          <Article
            key={article.title}
            title={article.title}
            image={article.image}
            text={article.text}
            hasActionButtons={index === ARTICLES.length - 1}
          />
        ))}
      </div>
    </>
  )
}

export default Bamboo
